import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Dropdown, Menu, Input, Checkbox } from 'antd';
import { Icon } from 'dlweb-components'
import * as _ from 'lodash';

const Search = Input.Search;

const QuickSearchBox = (props) => {

  const inputEl = useRef(null);
  const defaultOptions = [
    { id: 1, text: 'Filename', checked: true },
    { id: 2, text: 'Description', checked: false },
    { id: 3, text: 'Version Notes', checked: false },
    { id: 4, text: 'Property Values', checked: false },
    { id: 5, text: 'Full Text', checked: true },
    { id: 6, text: 'Workflow Comments', checked: false },
    { id: 7, text: "Use OR Operator", checked: true }
  ];

  const [visible, setVisible] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchOptions, setSearchOptions] = useState(defaultOptions);

  const onChange = (e, option) => {
    
    let optionsCopy = searchOptions;
    _.find(optionsCopy, { id: option.id }).checked = e.target.checked;
    
    localStorage.searchOptions = JSON.stringify(optionsCopy);
    setSearchOptions([...optionsCopy])
  }
  useEffect(() => {
    let localOptions = localStorage.searchOptions && JSON.parse(localStorage.searchOptions);
    if (localOptions && localOptions.length === 7) {
      setSearchOptions(localOptions);
    } else {
      localStorage.searchOptions = JSON.stringify(defaultOptions);
    }

  }, [])

  const handleVisibleChange = flag => {
    setVisible(flag)
  };

  const onSearch = (value) => {
    
    if(value === '') { return; }

    let stopListening = props.$rootScope.$on('$routeChangeSuccess', (e, data) => {
      if(data.originalPath !== '/search') {
        setSearchValue('');
        stopListening();
      }
    })

    const noOptions  = _.find(searchOptions, function(option) { return option.id < 7 && option.checked === true }) === undefined

    if (noOptions) {
      let optionsCopy = searchOptions;
      optionsCopy[0].checked = true;
      
      localStorage.searchOptions = JSON.stringify(optionsCopy);
      setSearchOptions([...optionsCopy]);
    }

    props.$location.url('/search').search({ q: value, page: 1, nocache: new Date().getTime() });
    props.$rootScope.$apply();
  }

  const menu = (
    <Menu>
      {
        searchOptions.map(searchOption => (
            <Menu.Item key={searchOption.id}>
              <Checkbox onChange={(e) => onChange(e, searchOption)} checked={searchOption.checked} optionId={searchOption.id}>{searchOption.text}</Checkbox>
            </Menu.Item>
          )
        )
      }
    </Menu>
  );
  
  const buttonDropdown = (
    <Dropdown 
      overlay={menu}
      trigger={['click']}
      placement="bottomRight"
      visible={visible}
      onVisibleChange={handleVisibleChange}
      
    >
      <IconContainer
        onClick={() => setVisible(!visible)}
      >
        <Icon type="chevron-down"/>
      </IconContainer>
    </Dropdown>
  
  )

  return (
    <QuickSearchContainer>
      <Search
        placeholder="Search Documents"
        onSearch={value => onSearch(value)}
        addonAfter={buttonDropdown}
        ref={inputEl}
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
      />
    </QuickSearchContainer>
    
  )
}

const QuickSearchContainer = styled.div`
  height: 50px;
  width: 400px;
  line-height: 50px;
  padding: 9px 12px 0 0;
  text-transform: none;
  box-sizing: border-box;
  float: right;
`

const IconContainer = styled.div`
  width: 100%;
  padding: 0 11px;
  line-height: 28px;
  font-size: 10px;
`

export default QuickSearchBox;